import { render, staticRenderFns } from "./ErrorBox.vue?vue&type=template&id=6d970e19"
import script from "./ErrorBox.vue?vue&type=script&lang=ts"
export * from "./ErrorBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports